require('./roundProgress.min.js');
module.exports = 'angular-svg-round-progressbar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-svg-round-progressbar/build/index.js
// module id = 11
// module chunks = 0